import patragriya1 from "./Screenshot_1-2.webp";
import patragriya2 from "./Screenshot_2-1.webp";
import patragriya3 from "./Screenshot_3.webp";

const patragriyaimg = [patragriya2, patragriya1, patragriya3];

export default patragriyaimg;
